import "core-js/modules/es7.array.includes";
// 获取边界内的随机数列表
export var getBatchRandom = function getBatchRandom(min, max, nums, ignores) {
  var randomArr = []; // 存储随机数数组

  var count = 0; // 统计变量，从0开始

  while (count < nums) {
    // 获取最大值和最小值之间的随机数
    var number = Math.floor(Math.random() * (max - min + 1) + min);

    if (!randomArr.includes(number)) {
      randomArr.push(number);
      count++;
    }
  }

  return randomArr;
}; // 洗牌算法

export var shuffle = function shuffle(array) {
  var m = array.length;
  var t, i; // 如果还剩有元素…

  while (m) {
    // 随机选取一个元素…
    i = Math.floor(Math.random() * m--); // 与当前元素进行交换

    t = array[m];
    array[m] = array[i];
    array[i] = t;
  }

  return array;
};
export var getBatch = function getBatch(max, min) {
  return Math.floor(Math.random() * (max - min + 1) + min);
};